import { useEffect, useState } from "react";
import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import type { Id } from "../../../convex/_generated/dataModel";

export function TypingIndicator({
  conversationId,
}: {
  conversationId: Id<"conversations">;
}) {
  const [bucket, setBucket] = useState(() => Math.floor(Date.now() / 2000) * 2000);
  useEffect(() => {
    const t = setInterval(
      () => setBucket(Math.floor(Date.now() / 2000) * 2000),
      2000,
    );
    return () => clearInterval(t);
  }, []);

  const typing = useQuery(api.typing.list, {
    conversationId,
    nowBucket: bucket,
  });

  if (!typing || typing.length === 0) {
    return <div className="h-4" />;
  }

  const names = typing.map((t) => t.name ?? "Someone");
  const text =
    names.length === 1
      ? `${names[0]} is typing...`
      : names.length === 2
        ? `${names[0]} and ${names[1]} are typing...`
        : `${names.length} people are typing...`;

  return (
    <div className="h-4 text-xs text-muted-foreground italic px-1">{text}</div>
  );
}
